var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.72 4.013a.348.348 0 10-.494.491l1.718 1.737L7.411.756a.35.35 0 00-.495-.494L1.945 5.25.72 4.013zm3.197 1.949a.349.349 0 00-.489.498l1.26 1.236 3.89-4.036a.349.349 0 10-.502-.484L4.674 6.704l-.757-.742z",
    fill: "#249995",
    fillRule: "evenodd",
    stroke: "#249995",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })));
}
export default SvgDoubleTick;